var webgl, currentSlide;

$(document).ready(init);

function init(){
    webgl = new Webgl($('.three'));
    Reveal.initialize({
        transition: 'linear', 
        transitionSpeed: 'fast',

        dependencies: [
            { src: 'assets/lib/reveal.js/plugin/highlight/highlight.js', async: true, callback: function() { 
                hljs.initHighlightingOnLoad(); 
            } },

        ] 
    });

    registerSlide('title');
    registerSlide('experiment');
    registerSlide('accident');
    registerSlide('three');
    registerSlide('engine');
    registerSlide('math');
    registerSlide('object');
    registerSlide('mesh');
    registerSlide('geometries');
    registerSlide('materials');
    registerSlide('lights');
    registerSlide('postprocessing');
    registerSlide('shaders');
    registerSlide('way');

    // webgl.tl.currentLabel('mesh');
    // Reveal.slide(8, 0);

    var gui = new dat.GUI();
    var fpostProcss = gui.addFolder('Post Processing');
    fpostProcss.add(webgl, 'usePostprocessing');

    var flight = gui.addFolder('Lights');
    var ctrl = flight.addColor(webgl, 'ambientColor');
    ctrl.onChange(function(){
        webgl.ambientLight.color.setRGB(webgl.ambientColor[0] / 255, webgl.ambientColor[1] / 255, webgl.ambientColor[2] / 255);
    });
    
    gui.close();

    $(window).on('resize', resizeHandler);

    animate();
}

function resizeHandler() {
    webgl.resize();
}

function registerSlide(slideId) { 
    Reveal.addEventListener(slideId, onSlideEnter);
}

function onSlideEnter(e) {
    if(currentSlide) {
        currentSlide.destroy();
        currentSlide = null;
    }

    var id = e.type;
    webgl.goTo(id);
}

function animate() {
    requestAnimationFrame(animate);
    if(currentSlide) currentSlide.update();
    webgl.render();
}



$(document).on('mousemove', function(e){
    if(currentSlide) currentSlide.onMouseMove(e.clientX, e.clientY);
});

$(window).on('mousedown', function(e){
    if(currentSlide) currentSlide.onMouseDown();
});

$(window).on('mouseup', function(e){
    if(currentSlide) currentSlide.onMouseUp();
});

$(window).on('resize', function(e){
    if(currentSlide) currentSlide.resize(window.innerWidth, window.innerHeight);
});

